/** CCMS section codes for catalog display (e.g. `10` → `010`, `PGA` unchanged). */
export function formatSectionLegacyId(legacyId?: string | null): string | null {
  const trimmed = legacyId?.trim();
  if (!trimmed) return null;
  return /^\d+$/.test(trimmed) ? trimmed.padStart(3, "0") : trimmed;
}

export function sectionCatalogSubhead(legacyId?: string | null): string | undefined {
  const formatted = formatSectionLegacyId(legacyId);
  return formatted ? `Section ID ${formatted}` : undefined;
}
